import { FC } from 'react';
import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';
import { RadioField, IRadioFieldProps } from './RadioField';
import * as React from 'react';

interface IProps extends IRadioFieldProps {
  formikProps: FormikProps<any>;
}

export const RadioFieldFormikWrapper: FC<IProps> = (props) => {
  const { formikProps, name, ...rest } = props;
  const { values, errors, touched, setFieldValue } = formikProps;

  const { t } = useTranslation();

  const getErrorMessage = (): string => {
    if (!errors[name] || !touched[name]) return '';
    if (typeof errors[name] === 'string') return t(`${errors[name]}`);
    const { data, message }: any = errors[name];
    return t(message, data);
  };

  const handleChange = (name: string, value: string | number) => {
    setFieldValue(name, value);
  };

  return (
    <RadioField
      error={getErrorMessage()}
      value={values[name]}
      onChange={handleChange}
      name={name}
      {...rest}
    />
  );
};
